import { Dispatch, SetStateAction } from 'react';

export const FREE_PRODUCT_KEYS = {
  CONFLUENCE: 'confluence.ondemand',
  JIRA_SOFTWARE: 'jira-software.ondemand',
  JIRA_CORE: 'jira-core.ondemand',
  JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand'
};

export type IconState =
  | 'PRIMARY_PRODUCT'
  | 'SECONDARY_PRODUCT'
  | 'MODAL_PRODUCT'
  | 'PRODUCT_ADDED';

export const ICON_STATES: { [index: string]: IconState } = {
  PRIMARY_PRODUCT: 'PRIMARY_PRODUCT',
  SECONDARY_PRODUCT: 'SECONDARY_PRODUCT',
  MODAL_PRODUCT: 'MODAL_PRODUCT',
  PRODUCT_ADDED: 'PRODUCT_ADDED'
};

export type ProductData = {
  readonly productKey: string;
  readonly productName: string;
  readonly productLogoUrl?: string;
  readonly productIconUrl?: string;
};
type BundleProvisioningStatusType =
  | 'waiting'
  | 'payload-ready'
  | 'provisioning'
  | 'success'
  | 'no-payload';

export type WacFreeBundlesPropsType = {
  readonly primaryProductKey: string;
  readonly secondaryProductKeys: string[];
  readonly signUpPath: string;
  readonly bundleMap: BundleMapType;
  readonly comparePlansUrl: string;
  readonly productData?: { [index: string]: ProductData };
  readonly featureFlags: featureFlags;
  readonly bundleProvisioningStatus?: BundleProvisioningStatusType;
  readonly setBundleProvisioningStatus?: Dispatch<
    SetStateAction<BundleProvisioningStatusType>
  >;
  readonly isModalOpen?: boolean;
  readonly setIsModalOpen?: Dispatch<SetStateAction<boolean>>;
  readonly cloudIdentifier?: string;
};

export type WacFreeBundlesModalPropsType = {
  readonly isModalOpen: boolean;
  readonly setIsModalOpen: Dispatch<SetStateAction<boolean>>;
  readonly primaryProductKey: string;
  readonly secondaryProductKeys: string[];
  readonly selectedSecondaryProductKey: string;
  readonly setSelectedSecondaryProductKey: Dispatch<SetStateAction<string>>;
  readonly bundleProvisioningStatus?: BundleProvisioningStatusType;
  readonly setBundleProvisioningStatus: Dispatch<
    SetStateAction<BundleProvisioningStatusType>
  >;
  readonly isSecondaryProductActivating?: boolean;
  readonly handleAgreeAndSignup: () => Promise<void>;
};

export type featureFlags = {
  readonly enableBundlesAfterSignup?: boolean;
  readonly enableBundlesPostSignupConfluence?: boolean;
};

export type PrimaryProductDisplayPropsType = {
  readonly productKey: string;
};

export type SecondaryProductSelectListPropsType = {
  readonly secondaryProductKeys: string[];
  readonly selectedSecondaryProductKey: string;
  readonly setSelectedSecondaryProductKey: Dispatch<SetStateAction<string>>;
};

export type SecondaryProductDisplayPropsType = {
  readonly productKey: string;
  readonly selected: boolean;
  readonly onSelect: () => void;
  readonly btnId: number;
};

export type SecondaryProductSelectButtonPropsType = {
  readonly isSelected: boolean;
  readonly handleClick: () => void;
  readonly btnId: number;
};

export type ProductIconPropsType = {
  readonly productKey: string;
  readonly iconState: IconState;
};

export type SecondaryProductSelectionContainerPropsType = {
  readonly selected: boolean;
};

export type BundleMapType = { [index: string]: string };

export type SiteReadyPropsType = {
  readonly productKey: string;
  readonly goToProduct: () => void;
  readonly takeMeBack: () => void;
};

export type ProductAddedPropsType = {
  readonly secondaryProductKey: string;
};
